import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoCtxMenu]'
})
export class MenuPreventDirective {

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }
}
